<template>
  <div id="polls">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <a
              :href="
                'https://vote.holacon.com?EventID=' +
                  $store.state.event.event.id
              "
              target="_blank"
              class="navbar-nav-link"
            >
              {{this.$t('event.buttons.goLiveVoting')}}
              <i class="icon-screen3 ml-1"></i>
            </a>
          </li>
          <li class="nav-item">
            <a
              href="javascript:;"
              class="navbar-nav-link"
              @click="
                updateForm = null;
                modalVisible = true;
              "
            >
              {{this.$t('event.components.participants.navbar.add')}}
              <i class="icon-plus3 ml-1"></i>
            </a>
          </li>
        </ul>
      </portal>
      <div class="content">
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{this.$t("event.menu.polls.title")}}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button icon="fas fa-redo-alt" size="mini" @click="refresh"></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="row" style="margin-top: 15px; margin-bottom: 15px; padding: 0px 20px">
            <div
              class="col-md-12"
              v-for="(item, index) in $store.state.polls.items"
              :key="item.id"
              style="margin: 10px 0px;  display: flex; flex-direction: row; background-color: rgb(245, 245, 245); padding: 0px"
            >
              <div style="display: flex; flex: 1; flex-direction: column">
                <div
                  style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; padding: 10px 15px;"
                >
                  <div>
                    <h3 style="margin: 0">{{ item.title }}</h3>
                    <span
                      style="background: #ddd; color: #000; padding: 3px 4px;"
                      v-if="item.sessionID != null && $store.state.livesessions.items.some(k => k.id == item.sessionID)"
                    >{{$t('event.tags.session')}}: {{ $store.state.livesessions.items.find(k => k.id == item.sessionID).title }}</span>
                  </div>
                  <div>
                    <el-tooltip class="item" effect="dark" :content="$t('event.table.edit')" placement="top">
                      <el-button
                        @click="editPoll(index)"
                        style="border: none; background: none; font-size: 17px; padding:0px 8px"
                        size="mini"
                        icon="fas fa-pen"
                      ></el-button>
                    </el-tooltip>
                    <el-popconfirm
                      :title="$t('createReport')"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.variables.no')"
                      @confirm="downloadReport(index)"
                    >
                      <el-tooltip
                        slot="reference"
                        class="item"
                        effect="dark"
                        :content="$t('event.buttons.downloadReport')"
                        placement="top"
                      >
                        <el-button
                          style="border: none; background: none; font-size: 17px; padding:0px 8px"
                          size="mini"
                          icon="el-icon-s-data"
                        ></el-button>
                      </el-tooltip>
                    </el-popconfirm>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="$t('event.buttons.showAnswers')"
                      placement="top"
                    >
                      <el-button
                        @click="getAnswers(index)"
                        style="border: none; background: none; font-size: 17px; padding:0px 8px"
                        size="mini"
                        icon="el-icon-s-comment"
                      ></el-button>
                    </el-tooltip>
                    <el-popconfirm
                      :title="$t('reminderAll')"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.variables.no')"
                      @confirm="sendNotification(index)"
                    >
                      <el-tooltip
                        slot="reference"
                        class="item"
                        effect="dark"
                        :content="$t('sendReminder')"
                        placement="top"
                      >
                        <el-button
                          style="border: none; background: none; font-size: 17px; padding:0px 8px"
                          size="mini"
                          icon="el-icon-message-solid"
                        ></el-button>
                      </el-tooltip>
                    </el-popconfirm>
                  </div>
                </div>
                <div
                  style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; padding: 10px 15px; background-color: #fff; border-left: 1px solid whitesmoke; border-right: 1px solid whitesmoke"
                >
                  <div class="answers">
                    <div
                      v-for="(answer, answerIndex) in item.answerRates"
                      class="answer"
                      style="display: flex; align-items: center; margin-bottom: 5px; cursor: pointer"
                      :key="answer.answer"
                      @mouseover="hoverSlice(index, answerIndex)"
                      @mouseleave="blurSlice(index, answerIndex)"
                    >
                      <div
                        style="width: 4px; height: 40px; margin-right: 10px; "
                        :style="'background-color:' + colors[answerIndex]"
                      ></div>
                      <div style="line-height: 15px;">
                        <span style="font-weight: 500">
                          {{
                          answer.answer
                          }}
                        </span>
                        <br />
                        <span>{{ answer.count }} | {{ answer.rate }}%</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div :ref="'chart' + index" :id="'chart' + index" class="chart"></div>
                  </div>
                </div>
                <div
                  style="background: whitesmoke; padding: 10px 15px; display: flex; flex-direction: row; align-items: center; justify-content: space-between"
                >
                  <el-switch
                    @change="togglePollActiveAnswers($event, index)"
                    :active-text="$t('event.components.moderation.vote.voteActive')"
                    :inactive-text="$t('event.components.moderation.vote.votePassive')"
                    v-model="$store.state.polls.items[index].isActiveAnswers"
                  ></el-switch>

                  <el-switch
                    @change="togglePollActive($event, index)"
                    :active-text="$t('event.components.moderation.vote.screenActive')"
                    :inactive-text="$t('event.components.moderation.vote.screenPassive')"
                    v-model="$store.state.polls.items[index].isActive"
                  ></el-switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="modalVisible"
      :title="$t('event.tags.editLive')"
      width="80%"
    >
      <PollAddUpdate
        @deleteMe="deleteItem"
        @closeMe="modalVisible = false"
        @itemUpdated="itemUpdated"
        @itemAdded="itemAdded"
        :data="updateForm"
      />
    </el-dialog>

    <el-dialog :visible.sync="answerModal" :title="$t('answers')" width="80%">
      <el-table :data="$store.state.polls.answers">
        <el-table-column :label="$t('event.table.participant')">
          <template slot-scope="scope">
            <ParticipantMini
              :data="
                $store.state.polls.participants.find(
                  k => k.id == scope.row.participantID
                )
              "
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('answer')" prop="answer"></el-table-column>
        <el-table-column :label="$t('event.table.date')">
          <template slot-scope="scope">
            {{
            $moment(scope.row.createDate).format(
            "DD MMMM YYYY dddd, HH:mm:ss"
            )
            }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
import PollAddUpdate from "../../components/PollAddUpdate";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import ParticipantMini from "../../components/ParticipantMini";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Polls",
  },
  components: { PollAddUpdate, PageCountInfo, ParticipantMini },
  name: "Tags",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "tags",
      am4core,
      colors: [],
      answerModal: false,
    };
  },
  methods: {
    downloadReport(index) {
      axios.post("poll/export", {id: this.$store.state.polls.items[index].id}).then(res => {
        this.$message.success(res.data.alert.message)
      })
    },
    async getAnswers(index) {
      await this.$store.dispatch("getPoll", index);
      this.answerModal = true;
    },
    async refresh() {
      await this.$store.dispatch("getPolls");
      this.initCharts();
    },
    editPoll(index) {
      this.updateForm = JSON.parse(
        JSON.stringify({
          ...this.$store.state.polls.items[index],
          chart: null,
          pieSeries: null,
        })
      );

      this.updateForm.answers.map((item, index) => {
        this.updateForm.answers[index] = {
          title: item,
          oldTitle: item,
        };
      });

      this.modalVisible = true;
    },
    sendNotification(index) {
      this.$store.dispatch("sendPollNotification", { index, context: this });
    },
    togglePollActive(val, index) {
      this.$store.dispatch("togglePollActive", { index, context: this });
    },
    togglePollActiveAnswers(val, index) {
      this.$store.dispatch("togglePollActiveAnswers", { index, context: this });
    },
    hoverSlice(index, answerIndex) {
      var slice = this.$store.state.polls.items[
        index
      ].pieSeries.slices.getIndex(answerIndex);
      slice.isHover = true;
    },

    blurSlice(index, answerIndex) {
      var slice = this.$store.state.polls.items[
        index
      ].pieSeries.slices.getIndex(answerIndex);
      slice.isHover = false;
    },
    async itemUpdated(item) {
      await this.$store.dispatch("getPolls");
      this.initCharts();
    },
    async itemAdded(item) {
      await this.$store.dispatch("getPolls");
      this.initCharts();
    },
    handleSizeChange(take) {
      this.$store.commit("setTagTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setTagPage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deletePoll", { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleTag", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedTags", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    initCharts() {
      this.$store.state.polls.items.map((item, index) => {
        this.$store.state.polls.items[index].chart = am4core.create(
          "chart" + index,
          am4charts.PieChart
        );

        this.$store.state.polls.items[index].chart.data = item.answerRates.map(
          (k, kindex) => {
            k.color = this.colors[kindex];
            return k;
          }
        );
        let pieSeries = this.$store.state.polls.items[index].chart.series.push(
          new am4charts.PieSeries()
        );
        pieSeries.dataFields.value = "count";
        pieSeries.dataFields.category = "answer";
        pieSeries.labels.template.disabled = true;

        this.$store.state.polls.items[index].pieSeries = pieSeries;
      });
    },
  },
  async mounted() {
    await this.$store.dispatch("getPolls");
    this.initCharts();
    this.$store.dispatch("getLiveSessions");
  },
  created() {
    let colorSet = new am4core.ColorSet();
    for (let i = 0; i < 8; i++) {
      this.colors.push(colorSet.next());
    }
  },
  computed: {
    skip() {
      return (
        (this.$store.state.tags.filter.page - 1) *
        this.$store.state.tags.filter.take
      );
    },
    take() {
      return this.skip + this.$store.state.tags.items.length;
    },
  },
  watch: {
    "$store.state.tags.filter.searchTerm": function () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getTags");
      }, 500);
    },
    "$store.state.tags.filter.groupID": function () {
      clearTimeout(this.timeout);
      this.$store.dispatch("getTags");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/event/Polls.vue